import axios from "axios";
import { API_URL } from "../../config";
export function _fetchConversations(params, token) {
  return new Promise((resolve, reject) => {
    let urlParams = new URLSearchParams(params).toString();
    axios
      .get(`${API_URL}chats?${urlParams}`, {
        headers:{
          Authorization: `JWT ${token}`
        }
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}